export const iconFontAwesomeWritingParagraph = (
	<i className="fa-solid fa-paragraph"></i>
);
